import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import BackBtn from "../../common/backBTN";

function ShowPromotion() {
 const { search } = useLocation();
  const id = new URLSearchParams(search).get("id");

  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!id) return;
    fetch(`${process.env.REACT_APP_API_URL}/api/promotions/${id}`)
      .then(res => res.json())
      .then(result => setData(result))
      .catch(console.error)
      .finally(() => setLoading(false));
  }, [id]);

  if (loading) return <p style={{ textAlign: "center" }}>Loading...</p>;
  if (!data) return <p style={{ textAlign: "center" }}>No data found</p>;

  const formatDesc = (raw = '') => {
    // If it already contains HTML block tags, just convert bare newlines to <br>
    const hasBlockTags = /<(p|div|ul|ol|li|h[1-6]|br)\b/i.test(raw);
    if (hasBlockTags) {
      return raw.replace(/\n/g, '<br>');
    }
    // Plain text: split on double newlines for paragraphs, single newline for <br>
    return raw
      .split(/\n{2,}/)
      .map(para => `<p>${para.replace(/\n/g, '<br>')}</p>`)
      .join('');
  };

  return (
    <div id="mc-animate-container" className="v-base v-detail-base fade-enter-done">
  <div className="_container_box">
    <div className="activity_container">
      <div className="shell-header">
        <div className="mc-navbar-blue this-mc-header am-navbar am-navbar-light">
         <BackBtn/>
          <div className="am-navbar-title">Promotion Details</div>
          <div className="am-navbar-right" />
        </div>
      </div>
      <div id="page_bg" className="common" />
      <div className="activity-detail-container">
        <div className="activity-detail-content">
          <div className="activity-info">
            <div className="activity-img"><img  src={`${process.env.REACT_APP_API_URL}/storage/${data.thumbnail}`} alt="" /></div>
            <div className="activity-title"><h5>{data.name}</h5></div>
          </div>
          <div className="activity-desc">
            <div className="activity-goto-btn icon-more" >GO</div>
            <div>
              <div className="wysiwyg">
               
               
                <div style={{margin: '0.5rem 0 0', padding: '0.5rem 0.5rem 0.6rem', background: '#111827', borderRadius: '0.16rem'}}>
                  <div
                    className="promo-desc-content"
                    dangerouslySetInnerHTML={{ __html: formatDesc(data.desc) }}
                  />
                </div>
                <style>{`
                  .promo-desc-content {
                    color: #e5e7eb;
                    font-size: 0.28rem;
                    line-height: 1.75;
                    word-break: break-word;
                    overflow-wrap: break-word;
                  }
                  .promo-desc-content p {
                    margin: 0.25rem 0;
                  }
                  .promo-desc-content strong,
                  .promo-desc-content b {
                    color: #f5c518;
                    font-weight: 700;
                  }
                  .promo-desc-content em,
                  .promo-desc-content i {
                    color: #f5c518;
                    font-style: italic;
                  }
                  .promo-desc-content ul,
                  .promo-desc-content ol {
                    padding-left: 1.4em;
                    margin: 0.2rem 0;
                  }
                  .promo-desc-content li {
                    margin: 0.18rem 0;
                    color: #e5e7eb;
                  }
                  .promo-desc-content a {
                    color: #f5a623;
                    text-decoration: underline;
                  }
                  .promo-desc-content h1,
                  .promo-desc-content h2,
                  .promo-desc-content h3,
                  .promo-desc-content h4 {
                    color: #f5c518;
                    font-weight: 700;
                    margin: 0.4rem 0 0.15rem;
                  }
                  .promo-desc-content hr {
                    border: none;
                    border-top: 1px solid rgba(255,255,255,0.15);
                    margin: 0.35rem 0;
                  }
                  .promo-desc-content table {
                    width: 100%;
                    border-collapse: collapse;
                    margin: 0.3rem 0;
                    font-size: 0.26rem;
                  }
                  .promo-desc-content td,
                  .promo-desc-content th {
                    border: 1px solid rgba(255,255,255,0.25);
                    padding: 0.12rem 0.2rem;
                    text-align: left;
                  }
                  .promo-desc-content th {
                    color: #f5c518;
                    background: rgba(255,255,255,0.05);
                  }
                `}</style>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
   
  </div>
</div>

  );
}
export default ShowPromotion;